export default __webpack_public_path__ + "static/media/trm-youshi.7ab689ea.png";